<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md8>
				<v-layout row wrap>
					<v-flex xs12>
						<ValidationProvider
							name="name"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								v-model="item.name"
								:label="$t('Name')"
								prepend-icon="mdi-account"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider
							name="email"
							rules="required|email"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								v-model="item.email"
								:label="$t('Email')"
								prepend-icon="mdi-email"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
							></v-text-field>
						</ValidationProvider>
					</v-flex>

					<v-flex xs12 v-if="!item.uuid">
						<ValidationProvider
							name="password"
							rules="required|min:8"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								v-model="item.password"
								:label="$t('label.password')"
								prepend-icon="mdi-lock"
								type="password"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
							></v-text-field>
						</ValidationProvider>
					</v-flex>

					<v-flex xs12 v-if="!item.uuid">
						<ValidationProvider
							name="password_confirmation"
							rules="required|min:8"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								:label="$t('label.password_confirmation')"
								v-model="item.password_confirmation"
								prepend-icon="mdi-lock"
								type="password"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<v-select
							v-model="item.role_id"
							:items="roles"
							item-value="id"
							item-text="name"
							:label="$t('label.role')"
							prepend-icon="mdi-account"
						></v-select>
					</v-flex>
					<v-flex xs12>
						<v-select
							v-model="item.tenant_id"
							:items="tenants"
							item-value="id"
							item-text="name"
							:label="$t('title.brands')"
							prepend-icon="mdi-account"
							@change="$emit('changeTenant')"
						></v-select>
					</v-flex>
					<v-flex xs12>
						<v-select
							v-model="item.outlet_ids"
							:items="outlets"
							item-value="id"
							item-text="name"
							:label="$t('title.outlets')"
							prepend-icon="mdi-account"
							multiple
						></v-select>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	props: ["value", "roles", "tenants", "outlets"],
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
};
</script>